// Public surface of `@auctogon/admin-frontend/gateways/native-device` (BL-2090,
// ADR 064 — Native Shell § 5). Callers import from here, never an adapter.
export type {
  AuthSessionOutcome,
  CameraSession,
  CameraShot,
  NativeCapability,
  NativeDeviceGateway,
  OpenAuthSessionInput,
  SaveFileInput,
} from './gateway';
export { CameraPermissionDeniedError, NativeCapabilityUnavailableError } from './gateway';
export type {
  NativeNotificationPermission,
  NativeTransferCapabilities,
  NativeTransferEnqueueResult,
  NativeTransferItem,
  NativeTransferListInput,
  NativeTransferQueue,
  NativeTransferResolveInput,
  NativeTransferResolveResult,
  NativeTransferRow,
  NativeTransferRowState,
  NativeTransferSummary,
} from './native-transfer/types';
export type {
  OfflineActiveScope,
  OfflineAuctionRecord,
  OfflineAuctionSyncSetting,
  OfflineCollection,
  OfflineEntrySize,
  OfflineMediaStaging,
  OfflineOutbox,
  OfflineRecordInput,
  OfflineRecordMap,
  OfflineRecords,
  OfflineReferenceRecord,
  OfflineScope,
  OfflineSessionRecord,
  OfflineStore,
  OfflineThumbnailAggregate,
  OfflineThumbnailDownloadInput,
  OfflineThumbnailDownloadOutcome,
  OfflineThumbnailInput,
  OfflineThumbnails,
  OfflineThumbnailSource,
  OutboxAppendInput,
  OutboxAppendResult,
  OutboxLocalWriteInput,
  OutboxLocalWriteResult,
  OutboxEntry,
  OutboxError,
  OutboxJson,
  OutboxStatus,
  OutboxUpdateInput,
  OutboxUpdateResult,
  StagedFile,
  StageFileInput,
  StageFileResult,
} from './offline-store/types';
export { OFFLINE_SESSION_RECORD_KEY, OFFLINE_STORE_IDLE_LIMIT_MS } from './offline-store/types';
export { OfflineStoreClosedError, isOfflineStoreFullError } from './offline-store/backend';
export { createReopeningScopeHandles } from './offline-store/reopening';
export { offlineRecordBytes } from './offline-store/records';
export { getNativeDeviceGateway, mayBeNativeApp, settledNativeAnswer } from './resolver';
export { wasNativeAppEmulationTurnedOff } from './emulation';
